const style = {
  cursor: "pointer",
  backgroundColor: "#F05050",
  border: 0,
  borderRadius: 10,
  outline: "solid 1px #909090",
  padding: 4,
  width: 24,
  height: 24
};

export function DeleteButton(props) {
  return (<>
    <button style={ style } onClick={ props.onClick }>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
      </svg>
    </button>
  </>);
}
